import Body from "../components/Body";
function Home() {
    return (
        <>
            <Body />
        </>
    )
}
export default Home;